import React from 'react';
import { cn } from '../../utils';

const StatsCard = ({ 
  title, 
  value, 
  icon: Icon, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const variants = {
    default: 'bg-gray-50 border border-gray-200 hover:bg-gray-100 hover:border-gray-300 hover:shadow-gray-200/50 dark:bg-gray-900/80 dark:border-gray-700 dark:hover:bg-gray-800 dark:hover:border-gray-600 dark:hover:shadow-black/30',
    success: 'bg-green-50 border border-green-200 hover:bg-green-100 hover:border-green-300 hover:shadow-green-200/50 dark:bg-green-900/20 dark:border-green-700/40 dark:hover:bg-green-900/30 dark:hover:border-green-600/50 dark:hover:shadow-black/30',
    warning: 'bg-orange-50 border border-orange-200 hover:bg-orange-100 hover:border-orange-300 hover:shadow-orange-200/50 dark:bg-orange-900/20 dark:border-orange-700/40 dark:hover:bg-orange-900/30 dark:hover:border-orange-600/50 dark:hover:shadow-black/30',
    danger: 'bg-red-50 border border-red-200 hover:bg-red-100 hover:border-red-300 hover:shadow-red-200/50 dark:bg-red-900/20 dark:border-red-700/40 dark:hover:bg-red-900/30 dark:hover:border-red-600/50 dark:hover:shadow-black/30',
    info: 'bg-blue-50 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 hover:shadow-blue-200/50 dark:bg-blue-900/20 dark:border-blue-700/40 dark:hover:bg-blue-900/30 dark:hover:border-blue-600/50 dark:hover:shadow-black/30'
  };

  const iconVariants = {
    default: 'text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-gray-800',
    success: 'text-green-600 bg-green-100 dark:text-green-300 dark:bg-green-900/30',
    warning: 'text-orange-600 bg-orange-100 dark:text-orange-300 dark:bg-orange-900/30',
    danger: 'text-red-600 bg-red-100 dark:text-red-300 dark:bg-red-900/30',
    info: 'text-blue-600 bg-blue-100 dark:text-blue-300 dark:bg-blue-900/30'
  };

  return (
    <div 
      className={cn(
        'group rounded-lg p-6 shadow-sm transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-105 cursor-pointer',
        variants[variant],
        className
      )}
      {...props}
    >
      <div className="flex items-center">
        {Icon && (
          <div className={cn(
            'flex-shrink-0 mr-4 p-3 rounded-full transition-all duration-300 ease-in-out group-hover:scale-110',
            iconVariants[variant]
          )}>
            <Icon className="h-6 w-6 transition-transform duration-300 ease-in-out group-hover:rotate-12" />
          </div>
        )}
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1 transition-colors duration-300">
            {title}
          </p>
          <p className={`text-2xl font-bold text-gray-900 dark:text-white transition-all duration-300 group-hover:text-gray-800 dark:group-hover:text-gray-100 group-hover:scale-105 ${className || ''}`}>
            {value}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
